'use strict';

import 'nls!./meeting_time_options.json';

const translationKey = 'MEETING_TIME';
const meetingTimeValues = [
  'flexible',
  'earlier',
  'morning',
  'noon',
  'afternoon',
  'evening',
  'night'
];

const selectOptions =  meetingTimeValues.map(function (value) {
  return {
    value: value,
    translationKey: translationKey + '.' +  value.toUpperCase()
  };
});

export default {
  selectOptions: selectOptions,
  all: selectOptions
    .reduce(function (preferredTimeOptions, preferredTimeOption) {
      preferredTimeOptions[preferredTimeOption.value] = preferredTimeOption;

      return preferredTimeOptions;
    }, {})
};



// WEBPACK FOOTER //
// ./app/src/constants/meeting_time_options.js